import { BaseService } from "@services/BaseService";

export type FormData = {
  name: string;
  email: string;
  subject: string;
  message: string;
};

class EmailService extends BaseService {
  sendContactEmail(data: FormData) {
    return this.post("/contact-us", data);
  }
}

export const emailService = new EmailService();
